import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

export type SetUserStatusV2Request =
  paths['/v2/users/me/status']['patch']['requestBody']['content']['application/json'];

export async function setUserStatusV2({ status }: SetUserStatusV2Request) {
  return fetchClient.PATCH('/v2/users/me/status', {
    body: {
      status,
    },
  });
}
